import { config } from "src/config/config";
import { APICallStatus } from "src/service/api_types";
import { ACCOUNT_ACTIONS } from "src/actions/account_actions";
import { SESSION_ACTIONS } from "src/actions/session_actions";
import { checkApiStatus } from "src/service/utils";
interface SessionState {
  isLoggedIn: boolean;
  currentAccount: {
    status: any;
    info: any;
  };
  updateAccount: {
    status: any;
  };
}

const buildDefaultState = (): SessionState => ({
  isLoggedIn: false, // Roadstead にログインしているかどうか
  currentAccount: {
    status: { status: APICallStatus.INIT },
    info: null,
  },
  updateAccount: {
    status: { status: APICallStatus.INIT },
  },
});

const defaultState: SessionState = buildDefaultState();

export const sessionReducer = (
  state: SessionState = defaultState,
  action: any
): SessionState => {
  switch (action.type) {
    case ACCOUNT_ACTIONS.INIT_GET_CURRENT_ACCOUNT: {
      if (config.APP_DEBUG) {
        console.log("ACCOUNT_ACTIONS.INIT_GET_CURRENT_ACCOUNT: ", action.data);
      }
      return {
        ...state,
        currentAccount: {
          ...state.currentAccount,
          status: { status: APICallStatus.INIT },
        },
      };
    }
    case ACCOUNT_ACTIONS.START_GET_CURRENT_ACCOUNT: {
      if (config.APP_DEBUG) {
        console.log("ACCOUNT_ACTIONS.START_GET_CURRENT_ACCOUNT: ", action.data);
      }
      return {
        ...state,
        currentAccount: {
          ...state.currentAccount,
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
    }
    case ACCOUNT_ACTIONS.GET_CURRENT_ACCOUNT_INFO: {
      if (config.APP_DEBUG) {
        console.log("ACCOUNT_ACTIONS.GET_CURRENT_ACCOUNT_INFO: ", action.data);
      }

      return {
        ...state,
        currentAccount: {
          ...state.currentAccount,
          status: { status: APICallStatus.SUCCEEDED },
          info: action.data,
        },
      };
    }
    case ACCOUNT_ACTIONS.INIT_UPDATE_CURRENT_ACCOUNT: {
      if (config.APP_DEBUG) {
        console.log(
          "ACCOUNT_ACTIONS.INIT_UPDATE_CURRENT_ACCOUNT: ",
          action.data
        );
      }
      return {
        ...state,
        updateAccount: {
          status: { status: APICallStatus.INIT },
        },
      };
    }
    case ACCOUNT_ACTIONS.START_UPDATE_CURRENT_ACCOUNT: {
      if (config.APP_DEBUG) {
        console.log(
          "ACCOUNT_ACTIONS.START_UPDATE_CURRENT_ACCOUNT: ",
          action.data
        );
      }
      return {
        ...state,
        updateAccount: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
    }
    case ACCOUNT_ACTIONS.UPDATE_CURRENT_ACCOUNT_INFO: {
      if (config.APP_DEBUG) {
        console.log(
          "ACCOUNT_ACTIONS.UPDATE_CURRENT_ACCOUNT_INFO: ",
          action.data
        );
      }

      let status = checkApiStatus(action.data.ajaxStat, null);
      if (status.status === APICallStatus.SUCCEEDED) {
        return {
          ...state,
          updateAccount: {
            status: status,
          },
          currentAccount: {
            info: action.data,
            status: status,
          },
        };
      } else {
        return {
          ...state,
          updateAccount: {
            status: status,
          },
        };
      }
    }
    case SESSION_ACTIONS.LOGIN_CREATED: {
      if (config.APP_DEBUG) {
        console.log("SESSION_ACTIONS.LOGIN_CREATED: ", action.data);
      }
      return {
        ...state,
        isLoggedIn: true,
      };
    }
    case SESSION_ACTIONS.LOGIN_DESTROYED: {
      if (config.APP_DEBUG) {
        console.log("SESSION_ACTIONS.LOGIN_DESTROYED: ", action.data);
      }
      return buildDefaultState();
    }

    default:
      return state;
  }
};
